/**
 * Member quotes for /beginner landing page (names/locations omitted on the page).
 * Replace with real testimonials you have permission to publish (and keep them accurate).
 */
export const BEGINNER_LANDING_TESTIMONIALS = [
  {
    quote: "I love your style—it's a lot easier than I expected.",
  },
  {
    quote: "I finally feel like I'm learning bridge properly.",
  },
  {
    quote: "I'm confident at the table now.",
  },
];
